import {observer} from "mobx-react-lite";
import {ISvgIconProps} from "../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {IModalDialogHandler} from "../../../../services/dialog/dialog.service.interface";
import {SheetDialogBox} from "./boxes/sheet-dialog.box";

interface SheetDialogProps {
    dialogHandler: IModalDialogHandler;
    iconSvg?: React.ComponentType<ISvgIconProps>;
}
export const SheetDialogComponent: React.FC<SheetDialogProps> = observer((props) => {
    return <SheetDialogBox>
        <div>Test mobile sheet modal</div>
    </SheetDialogBox>
})